<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="copy">
<p class="crtf">© 2006 Richard Bauckham</p>
<p class="crt">All rights reserved</p>
<p class="crtf">Published 2006 by</p>
<p class="crt">Wm. B. Eerdmans Publishing Co.</p>
<p class="crt">2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /</p>
<p class="crt">P.O. Box 163, Cambridge CB3 9PU U.K.</p>
<p class="cipf"><strong>Library of Congress Cataloging-in-Publication Data</strong></p>
<p class="cipf">Bauckham, Richard.</p>
<p class="cip1">Jesus and the eyewitnesses: the Gospels as eyewitness testimony / Richard Bauckham.</p>
<p class="cip3">p. cm.</p>
<p class="cip2">ISBN 978-0-8028-6390-4 (pbk.: alk. paper)</p>
<p class="cip2">ISBN 978-1-4674-2599-5 (pbk.: ePub)</p>
<p class="cip2">ISBN 978-1-4674-0898-1 (pbk.: Kindle)</p>
<p class="cip2">1. Jesus Christ — Historicity. 2. Bible. N.T. Gospels — Evidences, authority, etc. I. Title.</p>
<p class="crtf"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0003.vue?71355469